type LogLevel = "debug" | "info" | "warn" | "error";

interface LoggerOptions {
	level?: LogLevel;
	data?: unknown;
}

class Logger {
	private static instance: Logger;
	private isProduction: boolean;

	private constructor() {
		this.isProduction = process.env.NODE_ENV === "production";
	}

	public static getInstance(): Logger {
		if (!Logger.instance) {
			Logger.instance = new Logger();
		}
		return Logger.instance;
	}

	private shouldLog(level: LogLevel): boolean {
		if (this.isProduction) {
			// Production'da sadece error ve warn loglarını göster
			return level === "error" || level === "warn";
		}
		return true;
	}

	private formatMessage(message: string, options?: LoggerOptions): string {
		const timestamp = new Date().toISOString();
		const level = options?.level?.toUpperCase() || "INFO";
		return `[${timestamp}] [${level}] ${message}`;
	}

	public debug(message: string, data?: unknown): void {
		if (this.shouldLog("debug")) {
			console.debug(
				this.formatMessage(message, { level: "debug" }),
				data || ""
			);
		}
	}

	public info(message: string, data?: unknown): void {
		if (this.shouldLog("info")) {
			console.info(this.formatMessage(message, { level: "info" }), data || "");
		}
	}

	public warn(message: string, data?: unknown): void {
		if (this.shouldLog("warn")) {
			console.warn(this.formatMessage(message, { level: "warn" }), data || "");
		}
	}

	public error(message: string, data?: unknown): void {
		if (this.shouldLog("error")) {
			console.error(
				this.formatMessage(message, { level: "error" }),
				data || ""
			);
		}
	}
}

export const logger = Logger.getInstance();
